<div
    #dayContainer
    class="w-full h-full relative"
    (windowResized)="onWindowResized($event)"
    (pointermove)="onPointerMove($event)"
    (pointerleave)="onPointerLeave()"
    (click)="onClickSelectSlot($event)">
    @for (slot of allTimeslots; track slot.index) {
        <div
            class="relative h-[48px] border-b border-p-divider-border-color border-dashed"
            [ngClass]="{
                '!border-solid': slot.index % 4 == 3,
                'bg-today-color': isToday,
                'border-p-divider-border-color/50': !slot.isSelectable,
                'last:rounded-br-lg': isLastDay,
                'last:rounded-bl-lg': isFirstDay,
                '!bg-p-content-hover-background': slot.isDst,
            }">
            @if (slot.isDst) {
                @if (slot.index % 2 === 0) {
                    <div
                        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-muted-color"
                        >Daylight</div
                    >
                } @else {
                    <div
                        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-muted-color"
                        >Saving</div
                    >
                }
            }
        </div>
    }

    @if (sessionOutlineTop != null) {
        <fm-session-selector-outline
            class="absolute cursor-pointer w-full"
            [ngStyle]="{ 'top.px': sessionOutlineTop }"
            [sessionDuration]="sessionDuration"
            [sessionTime]="pointedAtSessionTime"
            [slotNumber]="slotNumber"
            [timezone]="timezone"
            [isToday]="isToday"
            [partnerAvailable]="pointedAtSessionInfo ? true : false" />
    }

    @for (timeslot of loadingSkeletonIndices; track timeslot; let j = $index) {
        <div
            class="flex items-center px-1.5 absolute w-full h-[48px] animation-fade-in-quick"
            [class.animation-fade-out-quick]="removingLoadingSkeletons"
            [ngStyle]="{ 'top.px': timeslot * 48 }">
            <p-skeleton size="36px"></p-skeleton>
        </div>
    }

    @for (timeslot of filteredPotentialPartnerData; track timeslot.sessionTime; let j = $index) {
        @if (
            timeslot.sessionTime < endOfDay &&
            timeslot.sessionTime >= dayData.startOfDay &&
            timeslot.sessionTime > currentTimeInMs
        ) {
            <fm-available-partner-tile
                [partnerInfo]="timeslot"
                [validPartner]="timeslot.partner ? true : false"
                [sessionTime]="timeslot.sessionTime"
                [sessionDuration]="timeslot.sessionDuration"
                [profilePhoto]="timeslot.partner?.profilePhoto"
                [profileSlug]="timeslot.partner?.profileSlug"
                [isSaved]="timeslot.partner?.saved"
                [isQuietMode]="timeslot.partner?.preferences.quietMode.value"
                [hasDirectBookablePartner]="timeslot.hasDirectBookablePartner"
                [hasAvailableGroupMeeting]="timeslot.hasAvailableGroupMeeting"
                [isSelectable]="sessionOutlineTop !== null"
                class="h-[48px] w-full absolute rounded-lg"
                [ngStyle]="{
                    'top.px': timeslot.slot * 48,
                    'left.px': 0,
                }" />
        }
    }

    @for (session of dayData.bookedSessionData; track session.id; let j = $index) {
        @if (session.startMs < endOfDay && session.startMs >= dayData.startOfDay) {
            <fm-booked-session-tile
                [sessionInfo]="session"
                [partnerInfo]="session.partner"
                [timezone]="timezone"
                [timeFormat]="timeFormat"
                [slotNumber]="session.slot"
                class="w-full absolute rounded-lg"
                [ngStyle]="{
                    'top.px': session.slot * 48 + 2,
                    'left.px': 2,
                }" />
        }
    }
    @for (groupBooking of dayData.bookedGroupMeetingData; track groupBooking.id; let j = $index) {
        @if (groupBooking.startMs < endOfDay && groupBooking.startMs >= dayData.startOfDay) {
            <fm-group-meeting-tile
                [groupMeetingInfo]="groupBooking"
                [timezone]="timezone"
                [timeFormat]="timeFormat"
                [slotNumber]="groupBooking.slot"
                [hidesClaim]="true"
                class="w-full absolute rounded-lg"
                [ngStyle]="{
                    'top.px': groupBooking.slot * 48 + 2,
                    'left.px': 2,
                }" />
        }
    }
    @for (
        selectedSession of dayData.selectedSessionData;
        track selectedSession.sessionTime;
        let j = $index
    ) {
        @if (
            selectedSession.sessionTime >= dayData.startOfDay &&
            selectedSession.sessionTime < endOfDay
        ) {
            <fm-selected-session-tile
                class="w-full absolute rounded-xl"
                [sessionDuration]="selectedSession.sessionDuration"
                [sessionTime]="selectedSession.sessionTime"
                [slotNumber]="selectedSession.slot"
                [booking]="selectedSession.booking"
                [timezone]="timezone"
                [ngStyle]="{
                    'top.px': selectedSession.slot * 48,
                }"
                >SELECTED</fm-selected-session-tile
            >
        }
    }

    <!-- Current time indicator -->
    @if (isToday) {
        <div
            class="absolute w-full border-t border-b border-red dark:border-orange-400 left-0 right-0 z-[100] pointer-events-none"
            [style.top]="timeLineTop + 'px'"></div>
        <div
            class="absolute w-[3px] h-3 bg-red dark:bg-orange-400 -left-[3px] z-[100] pointer-events-none"
            [style.top]="timeLineAnchorTop + 'px'"></div>

        <div
            class="absolute text-12 text-red dark:text-orange-400 font-semibold z-[100] bg-p-content-background"
            style="transform: translateX(calc(-100% - 3px))"
            [style.top]="timeLineAnchorTop + 'px'">
            <div class="relative">
                <!-- white gradient below the text -->
                <div
                    class="absolute w-full h-[8px] top-full left-0 pointer-events-none"
                    style="
                        background: linear-gradient(
                            to bottom,
                            var(--p-content-background) 0%,
                            transparent 100%
                        );
                    "></div>

                <!-- white gradient above the text -->
                <div
                    class="absolute w-full h-[8px] bottom-full left-0 pointer-events-none"
                    style="
                        background: linear-gradient(
                            to top,
                            var(--p-content-background) 0%,
                            transparent 100%
                        );
                    "></div>

                <!-- white gradient to the left of the text -->
                <div
                    class="absolute h-full w-[8px] top-0 right-full pointer-events-none"
                    style="
                        background: linear-gradient(
                            to left,
                            var(--p-content-background) 0%,
                            transparent 100%
                        );
                    "></div>

                <!-- white radial gradient in top left corner -->
                <div
                    class="absolute w-[8px] h-[8px] bottom-full right-full pointer-events-none"
                    style="
                        background: radial-gradient(
                            circle at bottom right,
                            var(--p-content-background) 0%,
                            transparent 70%
                        );
                    "></div>

                <!-- white radial gradient in bottom left corner -->
                <div
                    class="absolute w-[8px] h-[8px] top-full right-full pointer-events-none"
                    style="
                        background: radial-gradient(
                            circle at top right,
                            var(--p-content-background) 0%,
                            transparent 70%
                        );
                    "></div>

                <div class="relative pr-[3px] pointer-events-none">
                    {{
                        currentTimeInMs
                            | epochToTime
                                : {
                                      format: displayTimeFormat,
                                      timezone: timezone,
                                      trim: timeFormat == '12hr',
                                  }
                    }}
                </div>
            </div>
        </div>
    }
</div>
